"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodsExposeToWindow = void 0;
var MethodsExposeToWindow;
(function (MethodsExposeToWindow) {
    MethodsExposeToWindow["refreshAgentToken"] = "refreshAgentToken";
    MethodsExposeToWindow["invalidateSessionTokens"] = "invalidateSessionTokens";
    MethodsExposeToWindow["refreshSessionTokens"] = "refreshSessionTokens";
    MethodsExposeToWindow["notifyInteractionEnded"] = "notifyInteractionEnded";
    MethodsExposeToWindow["RaiseN2InIvrSuccess"] = "RaiseN2InIvrSuccess";
    MethodsExposeToWindow["RaiseN2InIvrFailure"] = "RaiseN2InIvrFailure";
    MethodsExposeToWindow["RaiseN2OTPInIvrSuccess"] = "RaiseN2OTPInIvrSuccess";
    MethodsExposeToWindow["RaiseN2OTPInIvrFailure"] = "RaiseN2OTPInIvrFailure";
    MethodsExposeToWindow["updateSignatureKeySuccess"] = "updateSignatureKeySuccess";
    MethodsExposeToWindow["updateSignatureKeyFailure"] = "updateSignatureKeyFailure";
    MethodsExposeToWindow["createPasswordOnboardingFinished"] = "createPasswordOnboardingFinished";
    MethodsExposeToWindow["verifyDataInIvrSuccess"] = "verifyDataInIvrSuccess";
    MethodsExposeToWindow["verifyDataInIvrFailure"] = "verifyDataInIvrFailure";
})(MethodsExposeToWindow || (exports.MethodsExposeToWindow = MethodsExposeToWindow = {}));
//# sourceMappingURL=types.js.map